import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [staff, setStaff] = useState(() => {
    const s = localStorage.getItem("boba_staff");
    return s ? JSON.parse(s) : null;
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("boba_token");
    if (!token) {
      setLoading(false);
      return;
    }
    api
      .get("/auth/me")
      .then((r) => {
        setStaff(r.data);
        localStorage.setItem("boba_staff", JSON.stringify(r.data));
      })
      .catch(() => {
        localStorage.removeItem("boba_token");
        localStorage.removeItem("boba_staff");
        setStaff(null);
      })
      .finally(() => setLoading(false));
  }, []);

  const login = async (pin) => {
    const { data } = await api.post("/auth/login", { pin });
    localStorage.setItem("boba_token", data.token);
    localStorage.setItem("boba_staff", JSON.stringify(data.staff));
    setStaff(data.staff);
    return data.staff;
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch (e) {
      // ignore
    }
    localStorage.removeItem("boba_token");
    localStorage.removeItem("boba_staff");
    setStaff(null);
  };

  return (
    <AuthContext.Provider value={{ staff, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
